import { useState } from "react";
import { Alert, Button, Card, Container, Row, Col } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useAgentContext } from "../../context/agent";
import ConfirmDeleteAgent from "./ConfirmDeleteAgent";
import ConfirmDisableAgent from "./ConfirmDisableAgent";
import { useOrgContext } from "../../context/org";
import AgentSettings from "./AgentSettings";
import {
    FaCog,
    FaExclamationTriangle,
    FaTrashAlt,
    FaPowerOff,
} from "react-icons/fa";

function Settings() {
    const [disableError, setDisableError] = useState("");
    const [deleteError, setDeleteError] = useState("");

    const [deleteAgent, setDeleteAgent] = useState(false);
    const [disableAgent, setDisableAgent] = useState(false);

    const { orgId, agentId } = useParams();
    const { getAgentById } = useAgentContext();
    const agent = getAgentById(agentId || "");

    const { membership } = useOrgContext();
    const isAllowed = ["owner", "admin", "editor"].includes(membership?.role || "");
    // const allowed = ["owner", "admin", "editor"];
    // const permission = !allowed.includes(membership?.role || "");

    if (!agent) return null;

    return (
        <>
            {deleteAgent && (
                <ConfirmDeleteAgent
                    agent={agent}
                    cancel={setDeleteAgent}
                    setError={setDeleteError}
                />
            )}
            {disableAgent && (
                <ConfirmDisableAgent
                    agent={agent}
                    cancel={setDisableAgent}
                    setError={setDisableError}
                />
            )}

            {/* Header */}
            <div
                style={{
                    backgroundColor: "#2d2d2d",
                    borderBottom: "1px solid #444",
                }}
                className="sticky-top"
            >
                <Container fluid className="py-3">
                    <Row className="align-items-center">
                        <Col>
                            <div className="d-flex align-items-center">
                                <div className="bg-primary rounded p-2 me-3">
                                    <FaCog className="text-white" />
                                </div>
                                <div>
                                    <h4 className="mb-0 text-light">
                                        Agent Settings
                                    </h4>
                                    <small
                                        style={{
                                        color: "#999",
                                        }}
                                    >
                                        Manage your agent configuration and preferences
                                    </small>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Container fluid className="py-4">
                {/* Agent Settings Form */}
                {orgId && agent && (
                    <Row className="mb-4">
                        <Col>
                            <AgentSettings
                                orgId={orgId}
                                agent={agent}
                            />
                        </Col>
                    </Row>
                )}

                {/* Danger Zone */}
                <Row>
                    <Col>
                        <Card
                            style={{
                                backgroundColor:
                                    "#2d2d2d",
                                borderColor: "#ffc107",
                            }}
                        >
                            <Card.Header
                                style={{
                                //     backgroundColor: "#ffc107",
                                    color: "#ffc107",
                                }}
                            >
                                <h5 className="mb-0">
                                    <FaExclamationTriangle className="me-2" />
                                    Danger Zone
                                </h5>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    {/* Disable Agent Section */}
                                    {agent.isPublished && (
                                        <Col
                                            xs={
                                                12
                                            }
                                            lg={
                                                6
                                            }
                                            className="mb-3 mb-lg-0"
                                        >
                                            <Card
                                                className="h-100"
                                                style={{
                                                    backgroundColor:
                                                        "#2d2d2d",
                                                    borderColor:
                                                        "#ffc107",
                                                }}
                                            >
                                                <Card.Body>
                                                    <div className="d-flex align-items-start">
                                                        <div className="bg-warning rounded p-2 me-3 mt-1">
                                                            <FaPowerOff className="text-dark" />
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <h6 className="mb-2 text-light">
                                                                Disable Agent
                                                            </h6>
                                                            <p
                                                                style={{
                                                                color: "#ccc",
                                                                }}
                                                                className="mb-3 small"
                                                            >
                                                                The agent will be unpublished and all deployments will stop working.
                                                            </p>
                                                            <Button
                                                                disabled={!isAllowed}
                                                                className={!isAllowed ? "disabled" : "" }
                                                                variant="outline-warning"
                                                                size="sm"
                                                                onClick={() =>
                                                                    setDisableAgent(
                                                                        true,
                                                                    )
                                                                }
                                                            >
                                                                <FaPowerOff className="me-2" />
                                                                Disable Agent
                                                            </Button>
                                                            {disableError && (
                                                                <Alert
                                                                    variant="danger"
                                                                    className="mt-3 mb-0"
                                                                >
                                                                    {
                                                                        disableError
                                                                    }
                                                                </Alert>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )}

                                    {/* Delete Agent Section */}
                                    <Col
                                        xs={
                                            12
                                        }
                                        lg={
                                            agent.isPublished
                                                ? 6
                                                : 12
                                        }
                                    >
                                        <Card
                                            className="h-100"
                                            style={{
                                                backgroundColor:
                                                    "#2d2d2d",
                                                borderColor:
                                                    "#dc3545",
                                            }}
                                        >
                                            <Card.Body>
                                                <div className="d-flex align-items-start">
                                                    <div className="bg-danger rounded p-2 me-3 mt-1">
                                                        <FaTrashAlt className="text-white" />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <h6 className="mb-2 text-light">
                                                            Delete Agent
                                                        </h6>
                                                        <p
                                                            style={{
                                                                color: "#ccc",
                                                            }}
                                                            className="mb-2 small"
                                                        >
                                                            Please be warned that once you delete this agent, this action cannot be undone. Ensure you're certain, as all uploaded data will be permanently deleted.
                                                        </p>
                                                        <p className="text-danger mb-3 small fw-bold">
                                                            This process is irreversible.
                                                        </p>
                                                        <Button
                                                            disabled={!isAllowed}
                                                            className={
                                                                !isAllowed
                                                                    ? "disabled"
                                                                    : ""
                                                            }
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() =>
                                                                setDeleteAgent(
                                                                    true,
                                                                )
                                                            }
                                                        >
                                                            <FaTrashAlt className="me-2" />
                                                            Delete Agent
                                                        </Button>
                                                        {deleteError && (
                                                            <Alert
                                                                variant="danger"
                                                                className="mt-3 mb-0"
                                                            >
                                                                {
                                                                    deleteError
                                                                }
                                                            </Alert>
                                                        )}
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Settings;
